'use strict';
var MixedSchema = require('./mixed'),
    inherits = require('./util/_').inherits;

module.exports = BooleanSchema;

function BooleanSchema() {
  if (!(this instanceof BooleanSchema)) return new BooleanSchema();

  MixedSchema.call(this, { type: 'boolean' });

  this.transforms.push(function (value) {
    if (this.isType(value)) return value;
    return /true|1/i.test(value);
  });
}

inherits(BooleanSchema, MixedSchema, {

  _typeCheck: function _typeCheck(v) {
    return typeof v === 'boolean';
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/yup/lib/boolean.js
// module id = 3641
// module chunks = 168707334958949